import Header from 'src/components/NewFeatures/Header/Header';

export default Header;
